import { Helmet } from 'react-helmet-async';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger
} from "../../components/ui/accordion";
import CTASection from '../../home/sections/CTA';
import { faqItems as faqs } from './faqItems';

export default function FAQPage() {
  return (
    <>
      <Helmet>
        <title>FAQ | Common Questions About MrJoe.Pro Contractor Software</title>
        <meta name="description" content="Find answers to frequently asked questions about MrJoe.Pro's AI-powered estimating and invoicing software for contractors. Learn about features, pricing, and how to get started." />
        <meta name="keywords" content="MrJoe.Pro FAQ, contractor software questions, estimate software help, invoicing FAQ, how to use MrJoe.Pro" />
        <link rel="canonical" href="https://mrjoe.pro/pub/mrjoe_faq" />
        
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://mrjoe.pro/pub/mrjoe_faq" />
        <meta property="og:title" content="FAQ | MrJoe.Pro" />
        <meta property="og:description" content="Get answers to common questions about MrJoe.Pro's contractor software features and functionality." />
        
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="FAQ | MrJoe.Pro" />
        <meta name="twitter:description" content="Get answers to common questions about MrJoe.Pro's contractor software features and functionality." />
      </Helmet>

      <section className="page-padding">
        <div className="container-safe">
          <h1 className="page-heading">Frequently Asked Questions</h1>
          <div className="bg-background xs:mt-10 mx-auto mt-6 max-w-[800px] md:mt-14">
            <Accordion type="multiple" defaultValue={[faqs[0]?.id ?? ""]}>
              {faqs.map((item) => (
                <AccordionItem key={item.id} value={item.id}>
                  <AccordionTrigger>{item.q}</AccordionTrigger>
                  <AccordionContent>
                    <p>{item.a}</p>
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </section>
      <CTASection />
    </>
  );
}